import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
    ChampDto,
    MoteurRegleTypeDateRefDto,
    MutationGetListeChampsGeneriqueArgs,
    MutationGetListeMoteurRegleTypeDateRefArgs,
    MutationGetListeTypeBenefGeneriqueArgs,
    TypeBenefDto,
} from 'src/graphql/generated-types';
import gql from 'graphql-tag';
import { tap } from 'rxjs/operators';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import { Injectable } from '@angular/core';
import { SharedAllocationAccessibilityLoadRelatedListAction } from 'src/app/_shared/stores/allocation-accessibility/shared-allocation-accessibility.action';

export class AllocationAccessibilityStateModel {

    accessibilityCriteriaList: ChampDto[] = null;

    referenceDatesList: MoteurRegleTypeDateRefDto[] = null;

    beneficiaryTypesList: TypeBenefDto[] = null;

    childrenAccessibilityCriteriaList: ChampDto[] = null;

}

@Injectable()
@State<AllocationAccessibilityStateModel>({
    name: 'sharedAllocationAccessibility',
    defaults: new AllocationAccessibilityStateModel()
})
export class SharedAllocationAccessibilityState {

    constructor(private readonly graphqlService: GraphqlService) {
    }

    // <editor-fold defaultstate="collapsed" desc="Selectors">

    @Selector()
    public static accessibilityCriteriaList(state: AllocationAccessibilityStateModel): ChampDto[] {
        return state.accessibilityCriteriaList || [];
    }

    @Selector()
    public static referenceDatesList(state: AllocationAccessibilityStateModel): MoteurRegleTypeDateRefDto[] {
        return state.referenceDatesList || [];
    }

    @Selector()
    public static beneficiaryTypesList(state: AllocationAccessibilityStateModel): TypeBenefDto[] {
        return state.beneficiaryTypesList || [];
    }

    @Selector()
    public static childrenAccessibilityCriteriaList(state: AllocationAccessibilityStateModel): ChampDto[] {
        return state.childrenAccessibilityCriteriaList || [];
    }

    // </editor-fold>

    // <editor-fold defaultstate="collapsed" desc="Actions">

    @Action(SharedAllocationAccessibilityLoadRelatedListAction)
    loadRelatedList({patchState, getState}: StateContext<AllocationAccessibilityStateModel>) {
        if (['accessibilityCriteriaList', 'beneficiaryTypesList', 'referenceDatesList', 'childrenAccessibilityCriteriaList'].every(e => getState()?.[e])) {
            return;
        }

        type mutations = 'GetListeChampsGenerique' | 'GetListeMoteurRegleTypeDateRef' | 'GetListeTypeBenefGenerique';
        type types =
            MutationGetListeChampsGeneriqueArgs
            | MutationGetListeMoteurRegleTypeDateRefArgs
            | MutationGetListeTypeBenefGeneriqueArgs;

        return this.graphqlService.mutateMultiple<mutations, types>({
            mutation: gql`
                mutation LoadRelatedList($contexte: ContextInfosInput) {
                    GetAccessibilityCriteria: GetListeChampsGenerique(
                        contexte: $contexte
                        critere: {
                            TakeChampListeValeur: true
                            TakeChampTypeDonnee: true
                            IsChampCritere: true
                        }
                    ) {
                        ChampDTO {
                            Id
                            Libelle
                            ChampTypeDonnee {
                                Code
                            }
                            ListChampListeValeur {
                                ChampListeValeurDTO {
                                    Id
                                    Valeur
                                    IsCloture
                                }
                            }
                        }
                    },
                    GetListeMoteurRegleTypeDateRef(
                        contexte: $contexte
                    ) {
                        MoteurRegleTypeDateRefDTO {
                            Id
                            Code
                            Libelle
                        }
                    }
                    GetListeTypeBenefGenerique(
                        contexte: $contexte
                        critere: {
                        }
                    ) {
                        TypeBenefDTO {
                            Id
                            Code
                            Libelle
                        }
                    },
                    GetChildrenAccessibilityCriteria: GetListeChampsGenerique(
                        contexte: $contexte
                        critere: {
                            TakeChampListeValeur: true
                            TakeChampTypeDonnee: true
                            IsChampCritereAD: true
                        }
                    ) {
                        ChampDTO {
                            Id
                            Libelle
                            ChampTypeDonnee {
                                Code
                            }
                            ListChampListeValeur {
                                ChampListeValeurDTO {
                                    Id
                                    Valeur
                                    IsCloture
                                }
                            }
                        }
                    }
                }
            `,
        }).pipe(
            tap((LoadRelatedList: any) => {
                patchState({
                    accessibilityCriteriaList: LoadRelatedList.GetAccessibilityCriteria?.ChampDTO || [],
                    referenceDatesList: LoadRelatedList.GetListeMoteurRegleTypeDateRef?.MoteurRegleTypeDateRefDTO || [],
                    beneficiaryTypesList: LoadRelatedList.GetListeTypeBenefGenerique?.TypeBenefDTO || [],
                    childrenAccessibilityCriteriaList: LoadRelatedList.GetChildrenAccessibilityCriteria?.ChampDTO || []
                });
            }),
        );
    }

}
